import { useForwardExpose } from "../shared/useForwardExpose.js";
import { MenuGroup_default } from "../Menu/MenuGroup.js";
import { createBlock, defineComponent, guardReactiveProps, normalizeProps, openBlock, renderSlot, unref, withCtx } from "vue";

//#region src/ContextMenu/ContextMenuGroup.vue?vue&type=script&setup=true&lang.ts
var ContextMenuGroup_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
	__name: "ContextMenuGroup",
	props: {
		asChild: {
			type: Boolean,
			required: false
		},
		as: {
			type: null,
			required: false
		}
	},
	setup(__props) {
		const props = __props;
		useForwardExpose();
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(MenuGroup_default), normalizeProps(guardReactiveProps(props)), {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 16);
		};
	}
});

//#endregion
//#region src/ContextMenu/ContextMenuGroup.vue
var ContextMenuGroup_default = ContextMenuGroup_vue_vue_type_script_setup_true_lang_default;

//#endregion
export { ContextMenuGroup_default };
//# sourceMappingURL=ContextMenuGroup.js.map